<template>
  <div class="carousel-container">
    <!-- 桌面端水平卡片轮播（保持不变） -->
    <el-carousel 
      v-if="isDesktop" 
      ref="outCarousel" 
      type="card" 
      height="55vh" 
      :autoplay="swiprAutoPlay" 
      trigger="click"
      direction="horizontal" 
      v-model="activeParentIndex" 
      @change="outSwiperChange"
    >
      <el-carousel-item v-for="(item, parentIndex) in carouselSlides" :key="parentIndex">
        <div class="item">
          <h3 class="medium">{{ item.title }}</h3>
          <p>{{ item.description }}</p>
          <div class="img-box">
            <el-carousel 
              ref="inCarousel" 
              height="370px" 
              :autoplay="activeParentIndex === parentIndex"
              indicator-position="none" 
              arrow="never" 
              @change="inSwiperChange" 
              :interval="4000"
            >
              <el-carousel-item v-for="(imgUrl, imgIndex) in item.imageArr" :key="imgIndex">
                <img :src="imgUrl" alt="轮播图片" />
                <div v-if="item.url" class="btn" @click="navToFun(item.url)">
                  <i class="el-icon-thumb"></i>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!-- 移动端高级设计 - 修复文本截断和按钮问题 -->
    <div v-else class="mobile-carousel">
      <!-- 背景层 -->
      <div class="mobile-bg" :style="{ backgroundImage: `url(${carouselSlides[activeMobileIndex].imageArr[0]})` }"></div>
      <div class="mobile-bg-overlay"></div>
      
      <!-- 主内容区 -->
      <div class="mobile-content">
        <!-- 页码指示器 - 确保可见 -->
        <div class="mobile-page-info">
          <span class="page-current">{{ String(activeMobileIndex + 1).padStart(2, '0') }}</span>
          <span class="page-divider">/</span>
          <span class="page-total">{{ String(carouselSlides.length).padStart(2, '0') }}</span>
        </div>

        <!-- 卡片内容 - 固定高度 -->
        <div class="mobile-card">
          <!-- 图片区域 - 固定高度 -->
          <div class="mobile-image-wrapper">
            <img :src="carouselSlides[activeMobileIndex].imageArr[0]" :alt="carouselSlides[activeMobileIndex].title" />
            <div class="image-overlay"></div>
            <div v-if="carouselSlides[activeMobileIndex].url" class="mobile-btn" @click="navToFun(carouselSlides[activeMobileIndex].url)">
              <i class="el-icon-thumb"></i>
              <span>查看详情</span>
            </div>
          </div>

          <!-- 文本区域 - 实现精确的行数限制 -->
          <div class="mobile-text">
            <h3 class="mobile-title">{{ carouselSlides[activeMobileIndex].title }}</h3>
            <p class="mobile-description">{{ carouselSlides[activeMobileIndex].description }}</p>
          </div>
        </div>

        <!-- 导航按钮 - 修复圆角问题 -->
        <div class="mobile-nav">
          <button class="nav-btn prev" @click="prevSlide" :disabled="activeMobileIndex === 0">
            <i class="el-icon-arrow-left"></i>
          </button>
          <div class="nav-dots">
            <span 
              v-for="(item, idx) in carouselSlides" 
              :key="idx"
              class="dot"
              :class="{ active: idx === activeMobileIndex }"
              @click="activeMobileIndex = idx"
            ></span>
          </div>
          <button class="nav-btn next" @click="nextSlide" :disabled="activeMobileIndex === carouselSlides.length - 1">
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NestedCarousel",
  data() {
    return {
      activeParentIndex: 0,
      swiprAutoPlay: false,
      activeMobileIndex: 0,
      carouselSlides: [
        {
          id: 1,
          title: "春芽共融：艺起生长的N种可能",
          description: `在春意盎然、万物莲勃生长的美好时节，由澳门扶康会与澳门培华中学共同策展，天汇星艺术空间为广大艺术爱好者们呈上"春芽共融：艺起生长的N种可能"主题艺术双展，致力让横琴的市民和各界朋友感受澳门孩子的纯真创意。`,
          imageArr: [
            require("../assets/images/artimgs/art01.png"),
            require("../assets/images/artimgs/art02.png"),
            require("../assets/images/artimgs/art03.png"),
            require("../assets/images/artimgs/art04.png"),
          ],
          url: ""
        },
        {
          id: 2,
          title: "“寻境数语”&“多元回响”",
          description: "为了庆祝澳门回归25周年加强横琴与澳门的文化互通和联系，“寻境数语”澳门科技艺术展与“多元回响”琴澳青年艺术联展，打造数字艺术的全新体验空间来展示琴澳青年艺术家作品。",
          imageArr: [
            require("../assets/images/artimgs/art2_1.png"),
            require("../assets/images/artimgs/art2_2.png"),
            require("../assets/images/artimgs/art2_3.png"),
            require("../assets/images/artimgs/art2_4.png"),
          ],
          url: "https://mp.weixin.qq.com/s/SlAOB8kn7wWLgMrxVlZWWw"
        },
        {
          id: 3,
          title: "曈星联盟之“壹魅力”杯 平衡车赛",
          description: "本次比赛是珠海首个将平衡车竞速与影视综合资源结合的赛事，亮点包括专业赛道设计、亲子互动环节以及“瞳星联盟”的明星选手表演赛。活动吸引了近500名参赛者及观众，在推广平衡车运动和提升横琴文旅形象方面成效显著。",
          imageArr: [
            require("../assets/images/artimgs/art3_1.png"),
            require("../assets/images/artimgs/art3_2.png"),
            require("../assets/images/artimgs/art3_3.png"),
          ],
          url: "https://mp.weixin.qq.com/s/JaS23DpjDNHTqwoImhGAkQ"
        },
        {
          id: 4,
          title: "「生生不息 边界‧探索」艺术作品展巡回展览",
          description: "由澳门自闭症协会主办的「生生不息 边界‧探索」艺术作品展巡回展览，2025年落地于天汇星艺术空间，期望以大湾区联展形式，打破公众对自闭症的认知边界，推动建立包容共生的社会环境。",
          imageArr: [
            require("../assets/images/artimgs/art4_1.png"),
            require("../assets/images/artimgs/art4_2.png"),
            require("../assets/images/artimgs/art4_3.png"),
            require("../assets/images/artimgs/art4_4.png"),
          ],
          url: ""
        },
        {
          id: 5,
          title: "“诗形物影”琴澳新篇 & 流转之间-多媒体水墨舞蹈剧场展演",
          description: "2025年艺术双展以科技赋能传统美学，融合诗意与水墨舞蹈。在“时、空、念”的流转中构筑流动剧场。邀您步入这场跨越边界、对话东西的感官奇遇，在流动的艺术中，探寻生命的无限诗意。",
          imageArr: [
            require("../assets/images/artimgs/art5_1.png"),
            require("../assets/images/artimgs/art5_2.png"),
            require("../assets/images/artimgs/art5_3.png"),
            require("../assets/images/artimgs/art5_4.png"),
          ],
          url: ""
        },
        {
          id: 6,
          title: "世界反法西斯战争胜利80周年粤澳姐妹学校合作区文艺汇演",
          description: "由澳门教育及青年发展局与横琴民生事务局联合主办的湾区中学生文艺汇演，在2500平方米户外广场成功举办。晚会汇集两地12所学校350余名师生，以多种表演形式，表达对抗战英烈的缅怀以及对中华文化的创新诠释。",
          imageArr: [
            require("../assets/images/artimgs/art6_1.png"),
            require("../assets/images/artimgs/art6_2.png"),
            require("../assets/images/artimgs/art6_3.png"),
          ],
          url: ""
        },
        {
          id: 7,
          title: "城市复调：琴澳之间的景观社会 — “洞”单元",
          description: "三位澳门艺术家以水泥、像素与玻璃为媒体，在固化、流动与透明间重构城市灵魂。独立空间交织成互相对话的“洞见形态”，构成了一场城市复调的感官奇遇与思想对话。",
          imageArr: [
            require("../assets/images/artimgs/art7_1.png"),
            require("../assets/images/artimgs/art7_2.png"),
            require("../assets/images/artimgs/art7_3.png"),
            require("../assets/images/artimgs/art7_4.png"),
          ],
          url: ""
        },
        {
          id: 8,
          title: "Championing all Voices! 共融艺术节",
          description: "本次活动致力借着艺术推动社会对残障群体的关注与理解，为边缘群体提供一个释放潜能、表达自我的舞台。令更多公共空间与文化平台见证伤健共融的美好时刻，实现真正的社会共融。",
          imageArr: [
            require("../assets/images/artimgs/art8_1.png"),
            require("../assets/images/artimgs/art8_2.png"),
            require("../assets/images/artimgs/art8_3.png"),
            require("../assets/images/artimgs/art8_4.png"),
          ],
          url: ""
        },
        {
          id: 9,
          title: "《ROLLOUT卫星点对点舞蹈影像展》",
          description: "ROLLOUT登陆横琴天汇星，开启琴澳“点对点”艺术对话。展览以肢体解构城市记忆，涵盖快拍挑战赛与八载经典回顾。27部佳作在光影流转间，呈现一场重塑时空的感官风暴。",
          imageArr: [
            require("../assets/images/artimgs/art9_1.png"),
            require("../assets/images/artimgs/art9_2.png"),
          ],
          url: ""
        },
        {
          id: 10,
          title: "儿童音乐剧《穿越时空的玛利亚》",
          description: "获横琴民生事务局支持指导、澳门售票网提供票务支持，琴澳首个户外儿童音乐剧于天汇星影视综合城户外广场成功落地。",
          imageArr: [
            require("../assets/images/artimgs/art10_1.png"),
            require("../assets/images/artimgs/art10_2.png"),
            require("../assets/images/artimgs/art10_3.png"),
            require("../assets/images/artimgs/art10_4.png"),
          ],
          url: ""
        },
        {
          id: 11,
          title: "艺脉汇 — ART We Meet",
          description: "四大艺术家呈现跨界「艺脉」，本次展览以「我们都在各自的艺术脉络中流动，因为热爱，上天让我们汇聚横琴」为主题，四位艺术家分别从医学、运动、纯艺等不同领域出发，展现澳门艺术生态的丰富层次与跨界可能。",
          imageArr: [
            require("../assets/images/artimgs/pending1_1.png"),
          ],
          url: ""
        },
      ],
      isDesktop: window.innerWidth >= 768,
      resizeTimer: null,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
  },
  methods: {
    navToFun(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },
    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.isDesktop = window.innerWidth >= 768;
      }, 200);
    },
    outSwiperChange(idx) {
      this.activeParentIndex = idx;
    },
    inSwiperChange(idx) {
      if (idx === 0) {
        this.$refs.outCarousel.next();
      }
    },
    prevSlide() {
      if (this.activeMobileIndex > 0) {
        this.activeMobileIndex--;
      }
    },
    nextSlide() {
      if (this.activeMobileIndex < this.carouselSlides.length - 1) {
        this.activeMobileIndex++;
      }
    },
  }
};  
</script>

<style scoped lang="scss">
.carousel-container {
  width: 100%;
  max-width: 1350px;
  margin: 0 auto;
}

/* 桌面端样式保持不变 */
.el-carousel__item {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.el-carousel__item p,
.el-carousel__item h3 {
  width: 95%;
}

.el-carousel__item p {
  height: 45px;
  text-align: justify;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-carousel__item .item {
  height: 100%;
  width: 100%;
  padding-bottom: 10px;
}

.img-box {
  position: relative;
  width: 100%;
  height: 100%;
}

.img-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;
}

.img-box .btn {
  position: absolute;
  right: 1rem;
  bottom: 2rem;
  background-color: white;
  box-shadow: 5px 5px 5px black;
  padding: 0.8rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  z-index: 1000;

  &:hover {
    box-shadow: none;
    background-color: #e1bd85;
    transition: all 0.3s ease;

    i {
      color: white;
    }
  }
}

/* 平板设备 */
@media (max-width: 992px) {
  :root {
    font-size: 14px;
  }

  .el-carousel__item h3.medium {
    font-size: 1.5rem;
    line-height: 2.5rem;
  }

  .el-carousel__item p {
    font-size: 1rem;
    padding: 0;
  }
}

/* ========== 移动端高级设计 - 修复所有问题 ========== */
@media (max-width: 768px) {
  .mobile-carousel {
    position: relative;
    width: 100%;
    min-height: 85vh;
    border-radius: 24px;
    overflow: hidden;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }

  /* 背景模糊层 */
  .mobile-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    filter: blur(30px) brightness(0.7);
    transform: scale(1.1);
    transition: background-image 0.5s ease;
  }

  .mobile-bg-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, 
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.3) 100%);
    backdrop-filter: blur(2px);
  }

  /* 主内容区 */
  .mobile-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 85vh;
    padding: 2rem 1rem;
  }

  /* 页码指示器 - 确保可见 */
  .mobile-page-info {
    position: absolute;
    top: 1rem;
    right: 1rem;
    display: flex;
    align-items: baseline;
    gap: 0.2rem;
    font-family: 'Georgia', serif;
    opacity: 0.9;
    z-index: 10;
    background: rgba(0, 0, 0, 0.3);
    padding: 0.3rem 0.8rem;
    border-radius: 30px;
    backdrop-filter: blur(5px);
  }

  .page-current {
    font-size: 2rem;
    font-weight: 600;
    color: white;
    line-height: 1;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  }

  .page-divider {
    font-size: 1.2rem;
    color: rgba(255, 255, 255, 0.8);
    margin: 0 0.1rem;
  }

  .page-total {
    font-size: 1.2rem;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 300;
  }

  /* 卡片容器 - 固定总高度 */
  .mobile-card {
    width: 100%;
    max-width: 340px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 28px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    transform: translateY(0);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    animation: slideUp 0.5s ease;
    height: 500px;
    display: flex;
    flex-direction: column;
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* 图片区域 - 固定高度 */
  .mobile-image-wrapper {
    position: relative;
    width: 100%;
    height: 260px;
    overflow: hidden;
    background: #f5f5f5;
    flex-shrink: 0;
  }

  .mobile-image-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .mobile-card:hover .mobile-image-wrapper img {
    transform: scale(1.05);
  }

  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, 
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.1) 100%);
  }

  /* 详情按钮 */
  .mobile-btn {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    padding: 0.5rem 1rem;
    border-radius: 40px;
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 500;
    color: #667eea;
    transition: all 0.3s ease;
    z-index: 10;
    border: 1px solid rgba(255, 255, 255, 0.3);

    &:hover {
      background: white;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    }

    i {
      font-size: 0.9rem;
    }

    span {
      letter-spacing: 0.5px;
    }
  }

  /* 文本区域 - 实现精确的行数限制 */
  .mobile-text {
    padding: 1.2rem;
    background: white;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  /* 标题：精确限制2行 */
  .mobile-title {
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.4;
    margin: 0 0 0.6rem 0;
    color: #2d2d2d;
    position: relative;
    padding-bottom: 0.6rem;
    flex-shrink: 0;
    
    /* 强制标题最多显示2行 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    max-height: 3.36em; /* 1.4 * 2 = 2.8, 再加点余量 */
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 3px;
      background: linear-gradient(90deg, #667eea, #764ba2);
      border-radius: 2px;
    }
  }

  /* 描述：精确限制4行 */
  .mobile-description {
    font-size: 0.85rem;
    line-height: 1.5;
    color: #666;
    margin: 0;
    text-align: justify;
    flex: 1;
    
    /* 强制描述最多显示4行 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    max-height: 6em; /* 1.5 * 4 = 6em */
  }

  /* 导航区域 - 完全居中且保持圆形 */
  .mobile-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    margin-top: 1.5rem;
    padding: 0 1rem;
    flex-shrink: 0;
  }

  /* 强制按钮保持圆形，不受挤压 */
  .nav-btn {
    width: 44px;
    min-width: 44px;
    height: 44px;
    border-radius: 50% !important;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    color: white;
    font-size: 1.2rem;
    padding: 0;
    line-height: 1;
    flex-shrink: 0;
    
    /* 确保完全圆形 */
    &, &:focus, &:active {
      border-radius: 50% !important;
      outline: none;
    }

    &:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.35);
      transform: scale(1.05);
    }

    &:active:not(:disabled) {
      transform: scale(0.95);
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }

  /* 点状指示器 */
  .nav-dots {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    flex-shrink: 0;
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    transition: all 0.3s ease;
    cursor: pointer;

    &.active {
      width: 20px;
      border-radius: 3px;
      background: white;
      box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
    }

    &:hover {
      background: rgba(255, 255, 255, 0.8);
    }
  }
}

/* 极小屏幕适配 */
@media (max-width: 480px) {
  .mobile-card {
    max-width: 300px;
    height: 480px;
  }
  
  .mobile-image-wrapper {
    height: 240px;
  }
  
  .mobile-text {
    padding: 1rem;
  }
  
  .mobile-title {
    font-size: 1.1rem;
    margin-bottom: 0.4rem;
    padding-bottom: 0.4rem;
  }
  
  .mobile-description {
    font-size: 0.8rem;
  }
  
  .mobile-nav {
    gap: 1rem;
  }
  
  .nav-btn {
    width: 40px;
    min-width: 40px;
    height: 40px;
    font-size: 1rem;
  }
  
  .mobile-page-info {
    top: 0.8rem;
    right: 0.8rem;
    padding: 0.2rem 0.6rem;
  }
  
  .page-current {
    font-size: 1.6rem;
  }
  
  .page-divider, .page-total {
    font-size: 1rem;
  }
}

@media (max-width: 380px) {
  .mobile-card {
    max-width: 280px;
    height: 460px;
  }
  
  .mobile-image-wrapper {
    height: 220px;
  }
  
  .mobile-text {
    padding: 0.8rem;
  }
  
  .mobile-title {
    font-size: 1rem;
    -webkit-line-clamp: 2;
    max-height: 2.8em;
  }
  
  .mobile-description {
    font-size: 0.75rem;
    -webkit-line-clamp: 4;
    max-height: 6em;
  }
}

.el-carousel__item h3.medium {
  color: #ae9281;
  font-weight: bold;
  margin: 0.5rem 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: white;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: white;
}
</style>